import { Reducer } from "redux";

import { FeedbacksAction, FeedbacksActionTypes, FeedbacksState } from "./types";

const initialState: FeedbacksState = {
  count: 0,
  items: [],
  dataIsLoading: false,
  chartItems: [],
  chartDataIsLoading: false,
};

const reducer: Reducer<FeedbacksState, FeedbacksAction> = (state = initialState, action) => {
  switch (action.type) {
    case FeedbacksActionTypes.TABLE_FETCH_REQUEST:
      return { ...state, dataIsLoading: true };
    case FeedbacksActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, items: results, dataIsLoading: false };
    }
    case FeedbacksActionTypes.TABLE_FETCH_ERROR:
      return { ...state, dataIsLoading: false };

    case FeedbacksActionTypes.CHART_FETCH_REQUEST:
      return { ...state, chartDataIsLoading: true };

    case FeedbacksActionTypes.CHART_FETCH_SUCCESS:
      return { ...state, chartItems: action.payload, chartDataIsLoading: false };

    case FeedbacksActionTypes.CHART_FETCH_ERROR:
      return { ...state, chartDataIsLoading: false };

    default:
      return state;
  }
};

export default reducer;
